import React, { useState } from "react";
import { createPortal } from "react-dom";
import { phoneDncStatus } from "../../../helpers/phoneDnc";

/**
 * One contact line. Phone numbers never show the saved "*" marker, which
 * means NOT on the DNC registry and read as the opposite; a number on the
 * registry is labelled DNC instead.
 */
function ContactLine({ contact, isPhone }) {
  if (!isPhone) {
    const value = typeof contact === "object" ? contact?.number : contact;
    // A long email in a narrow card column wraps after the "@", not mid-word.
    const at = typeof value === "string" ? value.indexOf("@") : -1;
    return at > 0 ? (
      <>
        {value.slice(0, at + 1)}
        <wbr />
        {value.slice(at + 1)}
      </>
    ) : (
      value
    );
  }

  const { number, type, isDnc } = phoneDncStatus(contact);
  return (
    <>
      {number}
      {type && <span className="contact_type_label"> ({type})</span>}
      {isDnc && <span className="contact_dnc_label">DNC</span>}
    </>
  );
}

export default function ContactInfoPopup({ contact_arr, heading, is_icon = false, type = null }) {
  const [isOpen, setIsOpen] = useState(false);
  const firstContact = contact_arr?.[0];
  // Phone records are objects and emails are strings. A caller that names no
  // type still gets phone treatment for phone records, as before the DNC label.
  const isPhone =
    type === "phone" || (type === null && typeof firstContact === "object" && firstContact !== null);
  // A phone record with no number has nothing to preview.
  const hasFirstContact =
    typeof firstContact === "object" && firstContact !== null ? Boolean(firstContact.number) : Boolean(firstContact);

  return (
    <>
      <div className="phone_email_flex flex">
        {hasFirstContact && (
          <a>
            {is_icon && (
              <img
                src={isPhone ? "/images/call-icon.svg" : "/images/email-icon.svg"}
                alt=""
              />
            )}
            <ContactLine contact={firstContact} isPhone={isPhone} />
          </a>
        )}
        {contact_arr?.length > 1 && (
          <span onClick={() => setIsOpen(true)}>+{contact_arr.length - 1} more</span>
        )}
      </div>

      {/*
        Portalled to <body>: the popup is a full-screen fixed overlay, but the
        search result card that renders it is `position: relative; z-index: 0`
        (see Result-property-blk.jsx). That traps the overlay's z-index inside
        the card, so the map, the filter bar and every later card painted over
        it and hid the close button. Any host may isolate itself the same way.
      */}
      {isOpen && createPortal(
        <div className="popup sm popup_password_change active contact_popup custom_contact_pop">
          <div className="table_dv">
            <div className="table_cell">
              <div className="contain">
                <div className="_inner">
                  <button type="button" className="x_btn" onClick={() => setIsOpen(false)}></button>
                  <div>
                    <h5>{heading}</h5>
                    {isPhone && (
                      <p className="phone_contact_info">
                        Numbers marked DNC are on the Do Not Call (DNC) registry.
                      </p>
                    )}

                    <ul>
                      {contact_arr?.map((contact, index) => (
                        <li key={index}>
                          <ContactLine contact={contact} isPhone={isPhone} />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
